/* tslint:disable */
/* eslint-disable */
/**
 * SmartAI WL
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ChatbotPerspectiveRole = {
    Standard: 'Standard',
    BeginnerFriendly: 'BeginnerFriendly',
    TechnicalExpert: 'TechnicalExpert',
    ExecutiveSummary: 'ExecutiveSummary'
} as const;
export type ChatbotPerspectiveRole = typeof ChatbotPerspectiveRole[keyof typeof ChatbotPerspectiveRole];


export function instanceOfChatbotPerspectiveRole(value: any): boolean {
    for (const key in ChatbotPerspectiveRole) {
        if (Object.prototype.hasOwnProperty.call(ChatbotPerspectiveRole, key)) {
            if (ChatbotPerspectiveRole[key as keyof typeof ChatbotPerspectiveRole] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ChatbotPerspectiveRoleFromJSON(json: any): ChatbotPerspectiveRole {
    return ChatbotPerspectiveRoleFromJSONTyped(json, false);
}

export function ChatbotPerspectiveRoleFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChatbotPerspectiveRole {
    return json as ChatbotPerspectiveRole;
}

export function ChatbotPerspectiveRoleToJSON(value?: ChatbotPerspectiveRole | null): any {
    return value as any;
}

export function ChatbotPerspectiveRoleToJSONTyped(value: any, ignoreDiscriminator: boolean): ChatbotPerspectiveRole {
    return value as ChatbotPerspectiveRole;
}

